import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiPasswordIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_password"}/>
}
